import MarketDataApiService from '@/services/api/serverless/market-data';

const FetchMarketData = {
  data() {
    return {
      contentLoading: false,
      summary: {},
    };
  },
  methods: {
    async loadMarketData(queryParams) {
      this.contentLoading = true;
      try {
        this.summary = await MarketDataApiService.getStatistics(queryParams).catch(() => ({}));
      } finally {
        this.contentLoading = false;
      }
    },
    resetMarketData() {
      this.summary = {};
    },
  },
};

export default FetchMarketData;
